<template >
  <div id="milkfarm-app" :style="cssVars" v-if="isLoaded">
    <!--<router-view v-slot="{ Component }">
      <transition name="fade" mode="out-in">
        <component :is="Component" />
      </transition>
    </router-view>-->
    <component :is="activeComponent"
               v-bind="{ saveSystem: this.saveSystem }"
               v-on:goto-view="(view) => {activeComponent = view;}"
               v-on:close="activeComponent = 'StartMenu'">
    </component>
  </div>
</template>

<script lang="ts">
import { Options, Vue } from 'vue-class-component'
import Milkfarm from '@/components/screens/Milkfarm.vue'
import StartMenu from "@/components/screens/StartMenu.vue"
import HelpMenu from "@/components/screens/HelpMenu.vue"
import SaveSystem from "@/SaveSystem"
import globalState from "@/store/globalState"
import PatchNotesScreen from "@/components/screens/PatchNotesScreen.vue"
import CreditsScreen from "@/components/screens/CreditsScreen.vue"

@Options({
  components: {
    Milkfarm, StartMenu, HelpMenu, PatchNotesScreen, CreditsScreen
  },
  methods: {
    log(msg: any) {
      console.log(msg)
    },
  },
  computed: {
    cssVars() {
      return {
        '--background-image': 'url(' + require('@/assets/frances-gunn-blurred-12.webp') + ')'
      }
    }
  },
  async created() {
    await globalState().load()
    this.saveSystem = new SaveSystem()
    //let farm = new Farm()
    //this.farm = farm
    this.isLoaded = true
  }
})
export default class App extends Vue {
  isLoaded = false
  activeComponent: string = 'StartMenu'
  saveSystem!: SaveSystem
}
</script>

<style lang="scss">
@import url('https://fonts.googleapis.com/css?family=Open+Sans:400,700');
@import url('https://fonts.googleapis.com/css?family=Maven+Pro:500');
//@import url('https://fonts.googleapis.com/css?family=Croissant+One'); // The Blushing Defeat title font

html {
  height: 100%;
}
body {
  background-color: #353540;
  margin: 0;
  min-height: 100%;

  display: flex;
  flex-direction: column;
  & > * {
    flex-shrink: 0;
  }
}
#app {
  flex-grow: 1;

  min-height: 100%;
  display: flex;
  flex-direction: column;
  & > * {
    flex-shrink: 0;
  }
}
#milkfarm-app {
  flex-grow: 1;

  //font-family: Avenir, Helvetica, Arial, sans-serif;
  font-family: "Open Sans", "Helvetica Neue", Avenir, Helvetica, Arial, sans-serif;
  font-size: 14px;
  line-height: 1.5;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  height: 100%;
  color: #fefefe;
  position: relative;
  background: linear-gradient(180deg, rgba($component-base-color, 0.1), rgba($component-base-color, 0.4)), var(--background-image);
  background-attachment: fixed;
  overflow-x: auto;

  h1, h2, h3, h4, h5 {
    font-family: "Maven Pro", "Open Sans", "Helvetica Neue", Avenir, Helvetica, Arial, sans-serif;
  }
}
a {
  color: white;
}
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s ease;
}
.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}
</style>
